import { Box, Button } from "@mui/material";

const MedicationFieldPreview = () => {
  return (
    <Box
      sx={{
        width: {
          xs: "100%",
          md: "80%",
        },
      }}
    >
      <Button variant="contained">Add Medication</Button>
    </Box>
  );
};
export default MedicationFieldPreview;
